module.exports = __webpack_public_path__ + "1c23ef57c23d1d8e9bd30557206df314.svg";